import { useThemeableSystemData } from './Provider';
import { useViewportSize } from './ProviderResponsive';
export var useThemeable = function () {
    var _a = useThemeableSystemData(), systemData = _a.systemData, svgPath = _a.svgPath, colorMode = _a.colorMode;
    var _b = useViewportSize(), viewportSize = _b.viewportSize, spacingMode = _b.spacingMode;
    var f = systemData.foundations;
    return {
        color: f.color[colorMode || 'light'], // Use effective colorMode, default to 'light' if undefined
        viewportSize: viewportSize,
        spacingMode: spacingMode,
        space: f.space[viewportSize || 'compact'],
        size: f.size[viewportSize || 'compact'],
        radius: f.radius[viewportSize || 'compact'],
        textFamily: f.text.family,
        textWeight: f.text.weight,
        textStyle: f.text[viewportSize || 'compact'],
        svgPath: svgPath,
    };
};
